var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("mdi-palette")])], 1)];
      }
    }])
  }, [_c('v-list', [_c('v-list-item-group', {
    model: {
      value: _vm.$s.theme,
      callback: function callback($$v) {
        _vm.$set(_vm.$s, "theme", $$v);
      },
      expression: "$s.theme"
    }
  }, _vm._l(_vm.themes, function (theme, i) {
    return _c('v-list-item', {
      key: "theme-".concat(i),
      on: {
        "click": _vm.setTheme
      }
    }, [_c('v-list-item-avatar', [theme ? _c('v-icon', {
      style: {
        color: _vm.$vuetify.theme.isDark ? theme.dark.primary : theme.light.primary
      }
    }, [_vm._v("mdi-checkbox-blank-circle")]) : _c('v-icon', [_vm._v("mdi-autorenew")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("Themes.".concat(i))))])], 1)], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }